import { IntegrationServiceId } from '../../../../../common/integrations'
import React, { type FC, useCallback } from 'react'
import { OnboardingBannerLayout } from '../../Components/OnboardingBannerLayout'
import { OnboardingBannerIntegrationButtons } from '../../Components/OnboardingBannerIntegrationButtons'
import { useTracking } from '../../../../../apps/professional-app/fa/common/tracking/hooks'
import { GrowthTrackEvent } from '../../../../../apps/professional-app/fa/common/tracking'
import { ZOOM_BANNER_COPIES } from '../../../copies/onboardingCopies'

interface ZoomOnboardingBannerProps {
  onDismiss?: () => void
  postConnectRedirectPath?: string | ((serviceId: IntegrationServiceId) => string)
}

export const ZoomOnboardingBanner: FC<ZoomOnboardingBannerProps> = ({ onDismiss, postConnectRedirectPath }) => {
  const { trackingClient } = useTracking()

  const handleIntegrationSelect = useCallback(() => {
    trackingClient.track({ eventName: GrowthTrackEvent.UPCOMING_ZOOM_BANNER_CLICKED })
  }, [trackingClient])

  return (
    <OnboardingBannerLayout title={ZOOM_BANNER_COPIES.title} subtitle={ZOOM_BANNER_COPIES.subtitle} onDismiss={onDismiss}>
      <OnboardingBannerIntegrationButtons
        integrationIds={[IntegrationServiceId.ZOOM]}
        postConnectRedirectPath={postConnectRedirectPath}
        onIntegrationSelect={handleIntegrationSelect}
      />
    </OnboardingBannerLayout>
  )
}
